import ApiService from '@/services/ApiService';

class ReferenceCodesService {
  static async getReferenceCodeConfig() {
    const composedURL = `/api3/company/reference_code_config`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async putReferenceCodeConfig(config) {
    const composedURL = `/api3/company/reference_code_config`;
    const response = await ApiService.put(composedURL, config);
    return response;
  }

  static async getGlobalReferenceCodeConfig() {
    const composedURL = `/api3/company/reference_code_config/global`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async putGlobalReferenceCodeConfig(config) {
    const composedURL = `/api3/company/reference_code_config/global`;
    const response = await ApiService.put(composedURL, config);
    return response;
  }

  static async getExclusiveReferenceCodeConfig() {
    const composedURL = `/api3/company/reference_code_config/exclusive`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async putExclusiveReferenceCodeConfig(config) {
    const composedURL = `/api3/company/reference_code_config/exclusive`;
    const response = await ApiService.put(composedURL, config);
    return response;
  }
}

export default ReferenceCodesService;
